import { XP_CONFIG } from './xpConfig';

// Total XP required to reach level n (1-indexed).
// L1=0, L2=100, L3=300, L4=600, L5=1000 → Ln = n*(n-1)/2 * FACTOR
export const totalXpForLevel = (level) => {
  if (level <= 1) return 0;
  return Math.floor(level * (level - 1) / 2) * XP_CONFIG.LEVEL_FACTOR;
};

export const getLevelFromXp = (totalXp) => {
  let level = 1;
  while (totalXpForLevel(level + 1) <= totalXp) level++;
  return level;
};

export const xpProgressInLevel = (totalXp) => {
  const level = getLevelFromXp(totalXp);
  const current = totalXpForLevel(level);
  const next = totalXpForLevel(level + 1);
  return (totalXp - current) / (next - current);
};

export const xpToNextLevel = (totalXp) => {
  const level = getLevelFromXp(totalXp);
  return totalXpForLevel(level + 1) - totalXp;
};

export const calculateWorkoutXP = ({ durationMinutes = 0, completedSets = 0 }) => {
  const base = XP_CONFIG.BASE_XP_PER_WORKOUT;
  const setsXP = completedSets * XP_CONFIG.XP_PER_SET;
  const durationXP = Math.min(Math.floor(durationMinutes * XP_CONFIG.XP_PER_MINUTE), XP_CONFIG.MAX_DURATION_XP);
  const total = base + setsXP + durationXP;
  return { base, setsXP, durationXP, total };
};
